// ============================================================
// 粒子/网格背景组件（轻量级 CSS 实现）
// ============================================================

import { useMemo } from 'react'

// ─── 样式 ───────────────────────────────────────────────────

const styles = {
  container: {
    position: 'fixed' as const,
    inset: 0,
    pointerEvents: 'none' as const,
    zIndex: 0,
    overflow: 'hidden' as const,
    background: 'linear-gradient(135deg, #0F0F1A 0%, #1A0F2E 50%, #0F0F1A 100%)',
  },
  grid: {
    position: 'absolute' as const,
    inset: 0,
    backgroundImage: `
      linear-gradient(rgba(139, 92, 246, 0.03) 1px, transparent 1px),
      linear-gradient(90deg, rgba(139, 92, 246, 0.03) 1px, transparent 1px)
    `,
    backgroundSize: '60px 60px',
  },
  orb: (size: number, x: string, y: string, color: string, delay: number) => ({
    position: 'absolute' as const,
    width: size,
    height: size,
    left: x,
    top: y,
    borderRadius: '50%',
    background: `radial-gradient(circle, ${color} 0%, transparent 70%)`,
    filter: 'blur(60px)',
    animation: `float ${8 + delay}s ease-in-out infinite`,
    animationDelay: `${delay}s`,
  }),
  particle: (x: string, delay: number, duration: number) => ({
    position: 'absolute' as const,
    width: 2,
    height: 2,
    left: x,
    bottom: '-10px',
    borderRadius: '50%',
    background: 'rgba(139, 92, 246, 0.6)',
    animation: `particleFloat ${duration}s linear infinite`,
    animationDelay: `${delay}s`,
  }),
}

// ─── 组件 ───────────────────────────────────────────────────

export default function ParticleBackground() {
  // 生成固定的粒子位置
  const particles = useMemo(() => {
    return Array.from({ length: 20 }, (_, i) => ({
      id: i,
      x: `${Math.random() * 100}%`,
      delay: Math.random() * 10,
      duration: 15 + Math.random() * 10,
    }))
  }, [])

  return (
    <div style={styles.container}>
      {/* 网格背景 */}
      <div style={styles.grid} />

      {/* 渐变光球 */}
      <div style={styles.orb(500, '-10%', '-10%', 'rgba(139, 92, 246, 0.15)', 0)} />
      <div style={styles.orb(400, '60%', '20%', 'rgba(236, 72, 153, 0.1)', 2)} />
      <div style={styles.orb(350, '20%', '60%', 'rgba(59, 130, 246, 0.1)', 4)} />
      <div style={styles.orb(300, '80%', '80%', 'rgba(16, 185, 129, 0.08)', 6)} />

      {/* 粒子 */}
      {particles.map((p) => (
        <div key={p.id} style={styles.particle(p.x, p.delay, p.duration)} />
      ))}
    </div>
  )
}
